import React, { Component } from 'react';
import { required, Toolbar, SaveButton, SelectInput, DateField, SimpleForm, ReferenceArrayInput, ReferenceField, 
	AutocompleteArrayInput, Button, NumberInput, Edit, Create, BooleanInput, EditButton, List, Datagrid, TextField,
	TextInput, AutocompleteInput, ReferenceInput, BooleanField, sanitizeListRestProps, useListContext,
	TopToolbar, FilterButton, CreateButton, ExportButton, FormDataConsumer } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';
import EntityToolbar from './components/EntityTooolbar';

const placementFilters = [
	<TextInput label="Search" source="search_name" alwaysOn resettable />,
	<ReferenceArrayInput source="site_id" label="Site" 
		reference="sites"
		basePath='sites'
		alwaysOn
		perPage={10}
		sort={{ field: 'name', order: 'ASC' }}
		filterToQuery={searchText => ({ search_name: searchText })}
		allowEmpty>
		<AutocompleteArrayInput label="Sites" optionText="adunit_path" optionValue="code" style={{ width: '90%' }} />
	</ReferenceArrayInput>,
	<NumberInput label="Placement ID" source="search_id" resettable />,
	<ReferenceArrayInput source="publisher_id" label="Publisher"
		reference="publishers"
		basePath='publishers'
		perPage={10}
		sort={{ field: 'name', order: 'ASC' }}
		filterToQuery={searchText => ({ search_name: searchText })}>
		<AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
	</ReferenceArrayInput>
];

const SiteButton = (props) => {
	var path = "/#/sites/" + props.record.site_id;
	return (
		<Button href={path} label="EDIT Site" variant="contained" color="primary" startIcon={<EditIcon />} />
	)
}

const ListActions = (props) => {
    const { className, maxResults, ...rest } = props;
    const { total } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <FilterButton />
            <CreateButton />
            <ExportButton disabled={total === 0} maxResults={30000} />
        </TopToolbar>
    );
};

export const PlacementList = (props) => (
	<List {...props} filters={placementFilters} perPage={25} bulkActionButtons={false} actions={<ListActions />}>
		<Datagrid rowClick="edit">
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
			<TextField source="site_name" label="Site" />
			<TextField source="publisher_name" label="Publisher" />
			<BooleanField source="active" label="Active" />
			<EditButton variant="contained" color="primary" />
		</Datagrid>
	</List>
);

const PlacementTitle = ({ record }) => {
	return <span>Placement {record ? `"${record.name}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
};
const siteRenderer = (choice) => {
	if (!choice || !choice.name) return '';
	return `${choice.name}  (${choice.publisher_name}) (${choice.code})`;
};
export const PlacementEdit = (props) => (
	<Edit title={<PlacementTitle />} {...props}>
		<SimpleForm toolbar={<EntityToolbar />}>
			<BooleanInput source="active" label="Active" defaultValue={true} validate={required()} style={{ width: '10%' }} />
			<TextField source="code" label="Placement ID" validate={required()} />
			<TextInput source="name" label="Placement Name" style={{ width: '400px' }} validate={required()} />

			<ReferenceField label="Site" source="site_id" reference="sites">
				<TextField source="name" />
			</ReferenceField>
			<SiteButton {...props} />
			<TextField source="adunit_path" label="Ad Unit Path" defaultValue="/64387298/" style={{ width: '400px' }} validate={required()} />
			<SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
				choices={[
						{ id: 1, name: 'At 1%' },
						{ id: 10, name: 'At 10%' },
						{ id: 20, name: 'At 20%' },
						{ id: 30, name: 'At 30%' },
						{ id: 40, name: 'At 40%' },
						{ id: 50, name: 'At 50%' },
						{ id: 60, name: 'At 60%' },
						{ id: 70, name: 'At 70%' },
						{ id: 80, name: 'At 80%' },
						{ id: 90, name: 'At 90%'},
						{ id: 100, name: 'At 100%'}
				]}
			/>
		</SimpleForm>
	</Edit>
);

export class PlacementCreate extends Component {
	state = {
		publisherId: ''
	}
	constructor(props) {
		super(props);
	}
	handlePublisherInputChanged = (value) => {
		this.setState({ publisherId: value });
	}
	siteFormFilter = (searchText) => {
		if (this.state.publisherId) return { search_name: searchText, publisher_id: this.state.publisherId };
		else return { search_name: searchText };
	}
	render() {
	return (
	<Create title={<PlacementTitle />} {...this.props}>
		<SimpleForm toolbar={<EntityToolbar />}>
			<BooleanInput source="active" label="Active" defaultValue={true} validate={required()} style={{ width: '10%' }} />
			<TextInput source="name" label="Placement Name" style={{ width: '400px' }} validate={required()} />
			<div style={{ width: '400px' }}>
			<ReferenceInput
				source="publisher_id"
				label="Publisher"
				reference="publishers"
				basePath="publishers"
				perPage={200}
				sort={{ field: 'name', order: 'ASC' }}
				onChange={this.handlePublisherInputChanged}
				filterToQuery={searchText => ({ search_name: searchText })}
				allowEmpty
				fullWidth>
				<AutocompleteInput label="Publishers" optionText="name" optionValue="code"/>
			</ReferenceInput>
			<ReferenceInput
				source="site_id"
				label="Site"
				reference="sites"
				basePath="sites"
				perPage={200}
				sort={{ field: 'name', order: 'ASC' }}
				filterToQuery={searchText => this.siteFormFilter(searchText)}
				allowEmpty
				fullWidth>
				<AutocompleteInput label="Sites" optionText={siteRenderer} optionValue="code" />
			</ReferenceInput>
			<SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
				choices={[
						{ id: 1, name:  'At 1%' },
						{ id: 10, name: 'At 10%' },
						{ id: 20, name: 'At 20%' },
						{ id: 30, name: 'At 30%' },
						{ id: 40, name: 'At 40%' },
						{ id: 50, name: 'At 50%' },
						{ id: 60, name: 'At 60%' },
						{ id: 70, name: 'At 70%' },
						{ id: 80, name: 'At 80%' },
						{ id: 90, name: 'At 90%'},
						{ id: 100, name: 'At 100%'}
				]}
			/>
			</div>
		</SimpleForm>
	</Create>
  )}
};